import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// Format category/tag values by replacing hyphens/underscores with spaces and capitalizing first letter
export function formatCategoryLabel(value: string | null | undefined): string {
  if (!value) return "";
  return value
    .replace(/[-_]/g, " ")
    .replace(/^\w/, c => c.toUpperCase());
}

// Format budget type for display
export function formatBudgetType(budgetType: string | null): string {
  if (!budgetType) return '';
  const labels: Record<string, string> = {
    'pgb': 'PGB',
    'wmo': 'Wmo',
    'wlz': 'WLZ',
    'zvw': 'Zvw',
    'particulier': 'Particulier',
    'organisatie': 'Organisatie',
    'interim': 'Interim (Organisatie)',
  };
  return labels[budgetType.toLowerCase()] || budgetType;
}

// Map a budget_type to a high-level "wie plaatst" group.
// - pgb -> pgb
// - particulier -> particulier
// - organisatie / interim / detachering / loondienst / zzp / wmo / wlz / zvw -> organisatie
export function getPostingGroup(budgetType: string | null | undefined): "pgb" | "particulier" | "organisatie" | null {
  if (!budgetType) return null;
  const v = budgetType.toLowerCase();
  if (v === "pgb") return "pgb";
  if (v === "particulier") return "particulier";
  if (["organisatie", "interim", "detachering", "loondienst", "zzp", "wmo", "wlz", "zvw"].includes(v)) {
    return "organisatie";
  }
  return null;
}

// Ensure a URL has a protocol. If it looks like a domain/path without protocol,
// prefix it with https:// so it is treated as an absolute URL by the browser.
export function ensureAbsoluteUrl(url: string | null | undefined): string | null {
  if (!url) return null;
  const trimmed = url.trim();
  if (!trimmed) return null;
  // Only http(s) links are allowed; javascript:, data: etc. are dropped.
  if (/^https?:\/\//i.test(trimmed)) return trimmed;
  if (/^[a-z][a-z0-9+.-]*:/i.test(trimmed) || trimmed.startsWith("//")) return null;
  return `https://${trimmed}`;
}
